import { getStepStatus, Paper, Step, Stepper, Text, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import * as React from 'react'
import { InstalacaoHeader } from 'view/instalacao/InstalacaoHeader'

interface AutorizarMunicipioLayoutProps {
  step: AutorizarMunicipioSteps
  children: React.ReactNode
  isProntuario: boolean
}

export enum AutorizarMunicipioSteps {
  ATIVAR,
  CONFIGURAR_AGENDA_PADRAO,
  IMPORTAR_CNES,
}

export const AutorizarMunicipioLayout = (props: AutorizarMunicipioLayoutProps) => {
  const { step, children, isProntuario } = props

  return (
    <PageContent>
      <VFlow vSpacing={2}>
        <InstalacaoHeader>
          <Stepper style={{ width: '480px', margin: '0 auto' }}>
            <Step title='Ativar instalação' status={getStepStatus(0, step)} />
            {isProntuario && <Step title='Configurar agenda padrão' status={getStepStatus(1, step)} />}
            <Step
              title='Importar CNES'
              subtitle={
                <Text component='p' fontStyle='italic' fontWeight='normal'>
                  Opcional
                </Text>
              }
              status={getStepStatus(2, step)}
            />
          </Stepper>
        </InstalacaoHeader>

        <Paper style={{ backgroundColor: 'white', padding: '2rem 2rem 0 2rem' }}>{children}</Paper>
      </VFlow>
    </PageContent>
  )
}
